import React from 'react';
import Projects from '../projects';

const ProjectsPage = () => <Projects />;

export default ProjectsPage;
